import React, { Component } from 'react';
import { Editors, Filters, Toolbar } from 'react-data-grid-addons';

import { formatEuro, formatDate } from './../DataGrid/Format';
import { ConseilorEditor, LoyaltyConquestEditor, ModelEditor, ShortnameEditor, TypeEditor } from './../DataGrid/Editors';
import DateEditor from './../DataGrid/DateEditor';
import ClientEditor from './../DataGrid/ClientEditor';
import BooleanFilter from './../DataGrid/BooleanFilter';
// import DateFilter from './../DataGrid/DateFilter';

const { DropDownEditor, CheckboxEditor } = Editors;
const { NumericFilter, AutoCompleteFilter, MultiSelectFilter, SingleSelectFilter } = Filters;

const AllColumns = (
  handleCheckbox: Function,
  conseilors: Array<Object>,
  dealerships: Array<Object>,
  models: Array<Object>,
) => {
  return [
    {
      key: 'type',
      name: 'Type',
      resizable: true,
      width: 60,
      editable: true,
      sortable: true,
      filterable: true,
      filterRenderer: SingleSelectFilter,
      editor: TypeEditor(),
    },
    {
      key: 'shortname',
      name: 'Affaire',
      resizable: true,
      width: 100,
      editable: true,
      sortable: true,
      filterable: true,
      filterRenderer: AutoCompleteFilter,
      editor: ShortnameEditor(dealerships),
    },
    {
      key: 'conseilor',
      name: 'Vendeur',
      resizable: true,
      width: 140,
      editable: true,
      sortable: true,
      filterable: true,
      filterRenderer: AutoCompleteFilter,
      editor: ConseilorEditor(conseilors),
    },
    {
      key: 'date',
      name: 'Date',
      resizable: true,
      editable: true,
      sortable: true,
      width: 100,
      formatter: formatDate,
      // filterable: true,
      // filterRenderer: DateFilter,
      editor: DateEditor,
    }, //Date
    {
      key: 'name',
      name: 'Nom du client',
      resizable: true,
      width: 140,
      editable: true,
      sortable: true,
      filterable: true,
      filterRenderer: AutoCompleteFilter,
      editor: ClientEditor,
    },
    {
      key: 'model',
      name: 'Modèle',
      resizable: true,
      editable: true,
      sortable: true,
      filterable: true,
      filterRenderer: AutoCompleteFilter,
      editor: ModelEditor(models),
    },
    {
      key: 'sl',
      name: 'SL',
      resizable: true,
      editable: true,
      sortable: true,
      formatter: <CheckboxEditor />,
      filterable: true,
      filterRenderer: BooleanFilter,
      onCellChange: handleCheckbox,
    }, //Oui ou non
    {
      key: 'price',
      name: 'Prix tarif',
      resizable: true,
      width: 134,
      editable: true,
      sortable: true,
      filterable: true,
      filterRenderer: NumericFilter,
      formatter: formatEuro,
    },
    {
      key: 'discount',
      name: 'Remise + surestim',
      resizable: true,
      // width: 165,
      editable: true,
      sortable: true,
      filterable: true,
      filterRenderer: NumericFilter,
      formatter: formatEuro,
    },
    {
      key: 'is_takeover',
      name: 'Reprise',
      resizable: true,
      editable: true,
      sortable: true,
      formatter: <CheckboxEditor />,
      filterable: true,
      filterRenderer: BooleanFilter,
      onCellChange: handleCheckbox,
    },
    {
      key: 'loyalty_conquest',
      name: 'Fidé / Conquête',
      resizable: true,
      width: 90,
      editable: true,
      sortable: true,
      filterable: true,
      filterRenderer: SingleSelectFilter,
      editor: LoyaltyConquestEditor(),
    }, //Conquête ou Fidé
    {
      key: 'is_takeover_twelve',
      name: 'Reprise > 12 ans',
      resizable: true,
      width: 85,
      editable: true,
      sortable: true,
      formatter: <CheckboxEditor />,
      filterable: true,
      filterRenderer: BooleanFilter,
      onCellChange: handleCheckbox,
    },
    { key: 'code', name: 'Immatriculation reprise', width: 128, resizable: true, editable: true, sortable: true, filterable: true },
    {
      key: 'bundle',
      name: 'Forfait',
      resizable: true,
      editable: true,
      sortable: true,
      formatter: <CheckboxEditor />,
      filterable: true,
      filterRenderer: BooleanFilter,
      onCellChange: handleCheckbox,
    }, //Oui ou non
    {
      key: 'engraving',
      name: 'Gravage',
      resizable: true,
      editable: true,
      sortable: true,
      formatter: <CheckboxEditor />,
      filterable: true,
      filterRenderer: BooleanFilter,
      onCellChange: handleCheckbox,
    }, //Oui ou non
    {
      key: 'pac',
      name: 'PAC',
      resizable: true,
      editable: true,
      sortable: true,
      formatter: <CheckboxEditor />,
      filterable: true,
      filterRenderer: BooleanFilter,
      onCellChange: handleCheckbox,
    },
    {
      key: 'pref',
      name: 'Préf',
      resizable: true,
      editable: true,
      sortable: true,
      formatter: <CheckboxEditor />,
      filterable: true,
      filterRenderer: BooleanFilter,
      onCellChange: handleCheckbox,
    },
    { key: 'comment', name: 'Commentaire', resizable: true, editable: true, sortable: true, filterable: true },
    {
      key: 'sold',
      name: 'Vendu',
      resizable: true,
      editable: true,
      sortable: true,
      formatter: <CheckboxEditor />,
      filterable: true,
      filterRenderer: BooleanFilter,
      onCellChange: handleCheckbox,
    },
    // {
    //   key: 'sold_other',
    //   name: 'Vendu autre concession',
    //   resizable: true,
    //   editable: true,
    //   sortable: true,
    //   formatter: <CheckboxEditor />,
    //   filterable: true,
    //   filterRenderer: BooleanFilter,
    //   onCellChange: handleCheckbox,
    // },
    // {
    //   key: 'sold_competition',
    //   name: 'Vendu concurrence',
    //   resizable: true,
    //   editable: true,
    //   sortable: true,
    //   formatter: <CheckboxEditor />,
    //   filterable: true,
    //   filterRenderer: BooleanFilter,
    //   onCellChange: handleCheckbox,
    // },
    {
      key: 'gap_aids',
      name: 'Ecart aides VPP',
      resizable: true,
      editable: false,
      sortable: true,
      filterable: true,
      filterRenderer: NumericFilter,
      formatter: formatEuro,
    },
    {
      key: 'gap_loa',
      name: 'Ecart LOA',
      resizable: true,
      editable: false,
      sortable: true,
      filterable: true,
      filterRenderer: NumericFilter,
      formatter: formatEuro,
    },
    {
      key: 'bonus_vd',
      name: 'Prime VD',
      resizable: true,
      editable: false,
      sortable: true,
      filterable: true,
      filterRenderer: NumericFilter,
      formatter: formatEuro,
    },
    {
      key: 'average_gap_vd',
      name: 'Ecart aides VD',
      resizable: true,
      sortable: true,
      editable: false,
      filterable: true,
      filterRenderer: NumericFilter,
      formatter: formatEuro,
    },
    {
      key: 'bonus_so',
      name: 'Prime SO',
      resizable: true,
      editable: false,
      sortable: true,
      filterable: true,
      filterRenderer: NumericFilter,
      formatter: formatEuro,
    },
    {
      key: 'average_gap_so',
      name: 'Ecart aides SO',
      resizable: true,
      sortable: true,
      editable: false,
      filterable: true,
      filterRenderer: NumericFilter,
      formatter: formatEuro,
    },
    {
      key: 'impact_loyalty',
      name: 'Fausse reprise fidé',
      resizable: true,
      sortable: true,
      editable: false,
      filterable: true,
      filterRenderer: NumericFilter,
      formatter: formatEuro,
    },
    {
      key: 'impact_conquest',
      name: 'Fausse reprise conq',
      resizable: true,
      sortable: true,
      editable: false,
      filterable: true,
      filterRenderer: NumericFilter,
      formatter: formatEuro,
    },

    {
      key: 'margin',
      name: 'Marge',
      resizable: true,
      editable: false,
      sortable: true,
      filterable: true,
      filterRenderer: NumericFilter,
      formatter: formatEuro,
    },
    {
      key: 'bmod',
      name: 'BMOD',
      resizable: true,
      editable: false,
      sortable: true,
      filterable: true,
      filterRenderer: NumericFilter,
      formatter: formatEuro,
    },
    {
      key: 'takeover',
      name: 'Reprise',
      resizable: true,
      editable: false,
      sortable: true,
      filterable: true,
      filterRenderer: NumericFilter,
      formatter: formatEuro,
    },
    {
      key: 'takeover_twelve',
      name: 'Reprise > 12 ans',
      resizable: true,
      width: 85,
      editable: false,
      sortable: true,
      filterable: true,
      filterRenderer: NumericFilter,
      formatter: formatEuro,
    },
    {
      key: 'takeover_conquest',
      name: 'Reprise conquête',
      resizable: true,
      editable: false,
      sortable: true,
      filterable: true,
      filterRenderer: NumericFilter,
      formatter: formatEuro,
    },
    {
      key: 'takeover_loyalty',
      name: 'Reprise fidé',
      resizable: true,
      editable: false,
      sortable: true,
      filterable: true,
      filterRenderer: NumericFilter,
      formatter: formatEuro,
    },
    {
      key: 'booster',
      name: 'Booster commandes immat',
      resizable: true,
      width: 105,
      editable: false,
      sortable: true,
      filterable: true,
      filterRenderer: NumericFilter,
      formatter: formatEuro,
    },
    {
      key: 'destocking',
      name: 'Destock',
      resizable: true,
      editable: false,
      sortable: true,
      filterable: true,
      filterRenderer: NumericFilter,
      formatter: formatEuro,
    },
    {
      key: 'pool',
      name: 'Pool',
      resizable: true,
      editable: false,
      sortable: true,
      filterable: true,
      filterRenderer: NumericFilter,
      formatter: formatEuro,
    },
    {
      key: 'total_aids',
      name: 'Total aides',
      resizable: true,
      editable: false,
      sortable: true,
      filterable: true,
      filterRenderer: NumericFilter,
      formatter: formatEuro,
    },
    {
      key: 'actions',
      name: '',
      resizable: true,
      width: 80,
    }
  ];
};

export default AllColumns;



// WEBPACK FOOTER //
// ./src/Components/Proposal/AllColumns.js